import { useDeleteShippingInfo } from "http-hooks/shippinginfo/useShippinginfo";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteShippingInfo({ id, onClose, setOpen }) {
  const { mutateAsync, isPending } = useDeleteShippingInfo();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Shipping Info"
      description="Are you sure you want to delete this shipping info? This shipping info will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
}
